export const VALIDATE_BUILDING = 'VALIDATE_BUILDING';
export const GET_BUILDING_BLOCKS = 'GET_BUILDING_BLOCKS';
export const VALIDATE_CLUSTER = 'VALIDATE_CLUSTER';
export const VALIDATE_BUILDING_ACCESS = 'VALIDATE_BUILDING_ACCESS';
export const GENERATE_CLIENT_REPORT = 'GENERATE_CLIENT_REPORT';
export const CLEAR_CLIENT_REPORT = 'CLEAR_CLIENT_REPORT';
